// Reactインポート
import React, { useState } from "react";

import { Helmet, HelmetProvider } from 'react-helmet-async'

// ゲットナビゲータ
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import ScrollToTop from "../ScrollToTop";
// タブページ
import TabsPortfolio from "./w-tabs/TabsPortfolio";

// スタイルインポート
import "../pages/css/works.scss";
import "../responsive/WorksResponsive.scss";
import "../common.scss";

// メインビジュアル
import headerSubImg from "../img/works/works-img.jpg";

// framer motion
import { motion } from "framer-motion";

function Portfolio() {
  return (
    <motion.div
      className="works"
      initial={{ width: 0 }}
      animate={{ width: "100%" }}
      exit={{ x: window.innerWidth, transition: { duration: 0.1 } }}
    >
    <HelmetProvider>
			<Helmet prioritizeSeoTags>
			<meta charset="utf-8" />
			<meta name="viewport" content="width=device-width, initial-scale=1" />
			<meta name="theme-color" content="#005bac" />
			<meta
				name="keywords"
				content="千葉県千葉市web制作,千葉市格安ホームページ制作,千葉市web集客,smartgenz,パドリナアレン,smartgenzとは？"
			/>
			<meta
				name="description"
				content="SmartGenzで皆様のビジネスを新たなレベルへ。千葉県千葉市を拠点とするSmartGenzは、千葉市内をはじめ全国の起業家、事業主、経営者の皆様からのご依頼を幅広く承っております。"
			/>
			<meta property="og:title" content="千葉県千葉市でのホームページ制作ならSmartGenz | ポートフォリオ" />
			<meta
				property="og:description"
				content="SmartGenzで皆様のビジネスを新たなレベルへ。千葉県千葉市を拠点とするSmartGenzは、千葉市内をはじめ全国の起業家、事業主、経営者の皆様からのご依頼を幅広く承っております。"
			/>
			<meta property="og:type" content="article" />
			<meta property="og:url" content="https://smartgenz.com/portfolio" />
			<meta property="og:image" content="%PUBLIC_URL%/smartgenz.jpg" />
			<meta property="og:site_name" content="千葉県千葉市でのホームページ制作ならSmartGenz | ポートフォリオ" />
			<meta property="og:locale" content="ja_JP" />
			<link rel="apple-touch-icon" href="%PUBLIC_URL%/smartgenz.jpg" />
			<link rel="manifest" href="%PUBLIC_URL%/manifest.json" />
			<link rel="icon" href="%PUBLIC_URL%/favicon.ico" />
			<link rel="canonical" href="https://smartgenz.com/portfolio" />
			<title>千葉県千葉市でのホームページ制作ならSmartGenz | ポートフォリオ</title>
			</Helmet>
		</HelmetProvider>
      <article className="sub-image">
        <div className="sub-main-image position-about">
          <img
            src={headerSubImg}
            alt="アイテム　｜ ヘッダーイメージ"
          ></img>
        </div>
      </article>
      <ScrollToTop />
      <section className="wrk-sec">
        <div className="sub-sec-company-ttl">
          <div className="borderA"></div>
          <h2 data-desc="ポートフォリオ">PORTFOLIO</h2>
          <div className="borderB"></div>
        </div>
      </section>
      <TabsPortfolio />
      <Contact />
      <Footer />
    </motion.div>
  );
}

export default Portfolio;
